// extracted by mini-css-extract-plugin
export default {"button":"BlockQuickAnswer_button__f7MdE"};